import axios from "axios";
import { Buffer } from "buffer";
const API_URL = process.env.REACT_APP_API_Link;
const API_ORIGIN = process.env.REACT_APP_API_ORIGIN;
const username = process.env.REACT_APP_API_USERNAME;
const password = process.env.REACT_APP_API_PASSWORD;
const token = Buffer.from(`${username}:${password}`, "utf8").toString("base64");

const getStates = () => {
  return axios({
    method: "GET",
    url: API_URL + "getStates",
    headers: {
      Authorization: `Basic ${token}`,
      "Access-Control-Allow-Origin": API_ORIGIN,
    },
  });
};
const getEmployees = (store) => {
  return axios({
    method: "GET",
    url: API_URL + "getEmployees/" + store,
    headers: {
      Authorization: `Basic ${token}`,
      "Access-Control-Allow-Origin": API_ORIGIN,
    },
  });
};
const getChoices = () => {
  return axios({
    method: "GET",
    url: API_URL + "getChoices",
    headers: {
      Authorization: `Basic ${token}`,
      "Access-Control-Allow-Origin": API_ORIGIN,
    },
  });
};
const getStoreLocation = () => {
  return axios({
    method: "GET",
    url: API_URL + "getStoreLocation",
    headers: {
      Authorization: `Basic ${token}`,
      "Access-Control-Allow-Origin": API_ORIGIN,
    },
  });
};
// function without trip sweepstake checkboxes

const regData = (bodyFormData) => {
  return axios({
    method: "POST",
    url: API_URL + "registerDataRaymour",
    data: bodyFormData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Basic ${token}`,
      "Access-Control-Allow-Origin": API_ORIGIN,
    },
  });
};
// function with trip sweepstake checkboxes
const regDataNew = (bodyFormData) => {
  return axios({
    method: "POST",
    url: API_URL + "registerDataRaymourBeta",

    data: bodyFormData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Basic ${token}`,
      "Access-Control-Allow-Origin": API_ORIGIN,
    },
  });
};

// function with trip sweepstake checkboxes with multiple value in choice
const regDataNewMultipleCheckbox = (bodyFormData) => {
  return axios({
    method: "POST",
    // url: API_URL + "registerDataRaymourUpdated",
    url: API_URL + "registerDataRaymourWithOptions",

    data: bodyFormData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Basic ${token}`,
      "Access-Control-Allow-Origin": API_ORIGIN,
    },
  });
};

const checkEmployee = (store, emp) => {
  return axios({
    method: "GET",
    url: API_URL + "checkEmployee/" + store + "/" + emp,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Basic ${token}`,
      "Access-Control-Allow-Origin": API_ORIGIN,
    },
  });
};
const checkGers = (gers) => {
  return axios({
    method: "GET",
    url: API_URL + "check-gers-exists/" + gers,
    headers: {
      Authorization: `Basic ${token}`,
      "Access-Control-Allow-Origin": API_ORIGIN,
    },
  });
};
const RegisterService = {
  getStates,
  regData,
  getEmployees,
  regDataNew,
  regDataNewMultipleCheckbox,
  getStoreLocation,
  checkEmployee,
  checkGers,
  getChoices,
};

export default RegisterService;
